var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-top-nav-top-inner"},[_c('span',{staticClass:"message"},[_vm._v(" Connect this site to your FutureLayer account. ")]),_c('v-btn',{staticClass:"btn-action",on:{"click":_vm.handleClaimSite}},[_vm._v(" Connect Site ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }